import { create } from "zustand";

type PaymentOptionStep = "firstPage" | "secondPage" | "finished";

interface PaymentOptionState {
  currentStep: PaymentOptionStep;
  goToStep: (step: PaymentOptionStep) => void;
}

export const usePaymentOptionStore = create<PaymentOptionState>()((set) => ({
  currentStep: "firstPage",
  goToStep: (step: PaymentOptionStep) =>
    set(() => ({
      currentStep: step,
    })),
}));
